// Australian Medicare card parsing / formatting helpers.
// Card = 10 digits displayed "XXXX XXXXX X"; IRN = 1 digit (1–9).
// Canonical stored form: "XXXX XXXXX X / N"

export function parseMedicare(raw) {
  if (!raw) return { digits: '', irn: '' };
  const s = String(raw);
  const slashIdx = s.indexOf('/');
  if (slashIdx >= 0) {
    const before = s.slice(0, slashIdx).replace(/\D/g, '').slice(0, 10);
    const after = s.slice(slashIdx + 1).replace(/[^1-9]/g, '').slice(0, 1);
    return { digits: before, irn: after };
  }
  const all = s.replace(/\D/g, '');
  const digits = all.slice(0, 10);
  const irnCandidate = all.slice(10, 11);
  const irn = /^[1-9]$/.test(irnCandidate) ? irnCandidate : '';
  return { digits, irn };
}

export function formatDigitsDisplay(d) {
  if (!d) return '';
  if (d.length <= 4) return d;
  if (d.length <= 9) return `${d.slice(0, 4)} ${d.slice(4)}`;
  return `${d.slice(0, 4)} ${d.slice(4, 9)} ${d.slice(9, 10)}`;
}

export function formatMedicare(d, irn) {
  const display = formatDigitsDisplay(d);
  if (!irn) return display;
  return `${display} / ${irn}`;
}

export function isValidMedicare(raw) {
  const { digits, irn } = parseMedicare(raw);
  return digits.length === 10 && /^[1-9]$/.test(irn);
}
